/* Fall Sale 活动页交互：邮件弹窗、Instagram 取码、创作者轮播、评论轮播
   所有查询都限定在 section 根节点内，支持主题编辑器里反复加载 */
(function () {
  function init(root) {
    if (!root || root.dataset.fsReady === 'true') return;
    root.dataset.fsReady = 'true';

    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    /* ---------- Hero 填满首屏：量出页头实际占位 ----------
       公告条、页头高度随主题设置和断点变化，写死会差一截。
       hero 的 top 偏移不受自身高度影响，所以这里不会形成回环。 */
    if (root.hasAttribute('data-fs-hero-fill')) {
      var hero = q('.fs-hero');
      /* 首屏要连 5% 优惠区一起装下时，还得把那一块的实测高度让出来 */
      var offer = root.hasAttribute('data-fs-hero-with-offer') ? q('.fs-offer') : null;

      if (hero) {
        var syncHeroMetrics = function () {
          var top = hero.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
          root.style.setProperty('--fs-hero-offset', Math.max(0, Math.round(top)) + 'px');

          if (offer) {
            root.style.setProperty('--fs-offer-h', Math.round(offer.getBoundingClientRect().height) + 'px');
          }
        };

        syncHeroMetrics();
        window.addEventListener('resize', syncHeroMetrics);
        window.addEventListener('load', syncHeroMetrics);

        /* 优惠区高度会随字体加载、文案改动变化；它的高度不受 hero 高度影响，不会形成回环 */
        if (offer && typeof ResizeObserver === 'function') {
          new ResizeObserver(syncHeroMetrics).observe(offer);
        }
      }
    }

    /* ---------- S2 商品卡：切换颜色色块 ----------
       加购提交本身交给主题的 product-form（它会打开购物车抽屉），
       这里只负责把选中的变体同步进隐藏的 id、价格和按钮状态。
       价格现在挪到了表单外面（标题同一行），所以统一以整张卡片（article）为范围查找，不再局限于 form 内。 */
    qa('[data-fs-swatches]').forEach(function (group) {
      var cardEl = group.closest('article');
      if (!cardEl) return;
      var swatches = group.querySelectorAll('.fs-swatch');

      swatches.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;

          swatches.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });

          var idInput = cardEl.querySelector('input[name="id"]');
          if (idInput) idInput.value = btn.dataset.variantId;

          var price = cardEl.querySelector('[data-fs-pair-price]');
          if (price) {
            var compare = btn.dataset.compare;
            price.innerHTML = compare
              ? '<span class="fs-price-sale"></span><s></s>'
              : '<span></span>';
            var parts = price.children;
            parts[0].textContent = btn.dataset.price || '';
            if (compare) parts[1].textContent = compare;
          }

          /* 展示状态来自每个色块上的 data-state（后台 metafield 解析而来），
             不再直接看 available —— 库存是多仓合计，分不出美国还是加拿大 */
          var button = cardEl.querySelector('.fs-buy-add');
          var label = cardEl.querySelector('[data-fs-pair-add-label]');
          var state = (btn.dataset.state || '').trim();
          if (!state) state = btn.dataset.available === 'true' ? 'in_stock' : 'sold_out';

          if (button) {
            button.dataset.state = state;
            button.disabled = state === 'sold_out';
            if (label) {
              if (state === 'sold_out') {
                label.textContent = button.dataset.labelSoldout;
              } else if (state === 'preorder') {
                label.textContent = button.dataset.labelPreorder || button.dataset.labelAdd;
              } else {
                label.textContent = button.dataset.labelAdd;
              }
            }
          }

          /* 页面自带的颜色图（和商品后台图片脱钩） */
          var media = cardEl.querySelector('[data-fs-color-images]');
          if (media) {
            var img = media.querySelector('[data-fs-color-img]');
            var colorMap;
            try { colorMap = JSON.parse(media.dataset.fsColorImages); } catch (e) { colorMap = null; }
            var colorName = btn.dataset.colorName;
            if (img && colorMap && colorMap[colorName]) {
              img.src = colorMap[colorName];
            }

            /* 悬停换图只在"默认那款颜色"下生效，切到别的颜色就关掉，
               不然悬停图（固定拍某一个颜色）会显示成别的颜色选项 */
            media.classList.toggle('fs-hover-ready', colorName === media.dataset.fsHoverColor);
          }
        });
      });
    });

    /* ---------- 邮件订阅弹窗 ---------- */
    var dialog = q('[data-fs-dialog]');
    var openBtn = q('[data-fs-open-signup]');

    if (dialog && openBtn) {
      var openDialog = function () {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      };
      var closeDialog = function () {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };

      openBtn.addEventListener('click', openDialog);

      var closeBtn = dialog.querySelector('[data-fs-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeDialog);

      /* 点击遮罩关闭（点在 dialog 方框之外才算） */
      dialog.addEventListener('click', function (e) {
        if (e.target !== dialog) return;
        var r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog();
      });

      /* Shopify 原生客户表单提交后整页刷新，成功时 URL 带 customer_posted=true。
         成功就自动弹回成功态；有校验错误则把弹窗重新打开让用户看到报错。 */
      var posted = false;
      try {
        posted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
      } catch (err) {
        posted = window.location.search.indexOf('customer_posted=true') !== -1;
      }

      if (posted) {
        dialog.classList.add('fs-dialog-success');
        openDialog();
      } else if (dialog.querySelector('.errors')) {
        openDialog();
      }
    }

    /* ---------- 一键复制折扣码 ---------- */
    var copyBtn = q('[data-fs-copy-code]');
    if (copyBtn) {
      var copyLabel = copyBtn.querySelector('[data-fs-copy-label]');
      var originalLabel = copyLabel ? copyLabel.textContent.trim() : '';
      var resetTimer;

      /* state: 'copied' 真的进了剪贴板（带 ✓）；'revealed' 只是把码显示出来（不带 ✓，
         免得顾客以为已复制其实没有） */
      var flashLabel = function (text, state) {
        if (!copyLabel) return;
        copyLabel.textContent = text;
        copyBtn.classList.remove('is-copied', 'is-revealed');
        copyBtn.classList.add(state === 'copied' ? 'is-copied' : 'is-revealed');
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          copyLabel.textContent = originalLabel;
          copyBtn.classList.remove('is-copied', 'is-revealed');
        }, 2500);
      };

      /* 剪贴板不可用时（非 https、旧浏览器、权限被拒）把码显示出来，
         至少让顾客能手动抄走，而不是点了没反应 */
      var showCodeInstead = function (code) {
        var status = q('[data-fs-post-status]');
        if (status) status.textContent = code;
        flashLabel(code, 'revealed');
      };

      copyBtn.addEventListener('click', function () {
        var code = copyBtn.dataset.code;
        if (!code) return;

        var onDone = function () { flashLabel(copyBtn.dataset.labelCopied || 'Code Copied', 'copied'); };
        var onFail = function () { showCodeInstead(code); };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(onDone).catch(onFail);
          return;
        }

        /* 降级路径：临时 textarea + execCommand */
        try {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.top = '0';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          var ok = document.execCommand('copy');
          document.body.removeChild(ta);
          if (ok) { onDone(); } else { onFail(); }
        } catch (err) {
          onFail();
        }
      });
    }

    /* ---------- 创作者横向轮播 ---------- */
    var track = q('[data-fs-creator-track]');
    var cPrev = q('[data-fs-creator-prev]');
    var cNext = q('[data-fs-creator-next]');

    if (track && cPrev && cNext) {
      var syncCreator = function () {
        cPrev.disabled = track.scrollLeft < 2;
        cNext.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      var snapTimer;
      var moveCreator = function (dir) {
        var item = track.querySelector('.fs-creator');
        if (!item) return;

        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var step = item.getBoundingClientRect().width + gap;
        var max = track.scrollWidth - track.clientWidth;
        var target = Math.max(0, Math.min(track.scrollLeft + dir * step, max));

        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          track.scrollLeft = target;
          return;
        }

        /* Chromium 下 scroll-snap-type: x mandatory 会让 behavior:'smooth' 的滚动直接不生效，
           滚动期间临时摘掉 snap，落位后再恢复。 */
        clearTimeout(snapTimer);
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: target, behavior: 'smooth' });
        snapTimer = setTimeout(function () {
          track.style.scrollSnapType = '';
          syncCreator();
        }, 500);
      };

      cPrev.addEventListener('click', function () { moveCreator(-1); });
      cNext.addEventListener('click', function () { moveCreator(1); });
      track.addEventListener('scroll', syncCreator);
      window.addEventListener('resize', syncCreator);
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          moveCreator(e.key === 'ArrowRight' ? 1 : -1);
        }
      });
      syncCreator();
    }

    /* ---------- 评论轮播 ---------- */
    var slides = qa('.fs-review-slide');
    var counter = q('[data-fs-review-count]');
    var rPrev = q('[data-fs-review-prev]');
    var rNext = q('[data-fs-review-next]');

    if (slides.length && rPrev && rNext) {
      var index = 0;
      var animating = false;
      var TRANSITION_MS = 420;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var moveReview = function (dir) {
        if (animating || slides.length < 2) return;
        var nextIndex = (index + dir + slides.length) % slides.length;
        var fromEl = slides[index];
        var toEl = slides[nextIndex];
        animating = true;

        /* 先把目标卡片放到屏幕外（不带过渡），再在下一帧触发滑入，
           同时把当前卡片滑向另一侧——方向由 dir 决定，左右滑动切换 */
        toEl.hidden = false;
        toEl.style.transition = 'none';
        toEl.style.transform = 'translateX(' + (dir > 0 ? '100%' : '-100%') + ')';
        toEl.getBoundingClientRect();
        toEl.style.transition = '';

        requestAnimationFrame(function () {
          fromEl.style.transform = 'translateX(' + (dir > 0 ? '-100%' : '100%') + ')';
          toEl.style.transform = 'translateX(0)';
        });

        setTimeout(function () {
          fromEl.hidden = true;
          fromEl.style.transform = '';
          index = nextIndex;
          animating = false;
          if (counter) counter.textContent = pad(index + 1) + ' / ' + pad(slides.length);
        }, TRANSITION_MS);
      };
      rPrev.addEventListener('click', function () { moveReview(-1); });
      rNext.addEventListener('click', function () { moveReview(1); });
      /* 只有一条评论时隐藏箭头和计数 */
      if (slides.length < 2) {
        rPrev.hidden = true;
        rNext.hidden = true;
        if (counter) counter.hidden = true;
      }
      /* 首屏状态已经由服务端渲染好了（第一张可见，其余 hidden），这里只需要把计数器文案对上 */
      if (counter) counter.textContent = pad(index + 1) + ' / ' + pad(slides.length);
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-fall-sale]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* 主题编辑器：section 重新渲染后重新绑定 */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
